export const GisJkh = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5227 22.2H17.1008V1.80005H5.62578V9.45005H12.3195V11.5219H11.5227V12.7969H12.3195V14.7094H11.5227V15.9844H12.3195V17.5782H11.5227V18.8532H12.3195V20.6063H11.5227V22.2ZM9.13203 5.3063H7.53828V3.71255H9.13203V5.3063ZM12.3195 5.3063H10.7258V3.71255H12.3195V5.3063ZM15.1883 5.3063H13.5945V3.71255H15.1883V5.3063ZM15.1883 8.17505H13.5945V6.5813H15.1883V8.17505ZM15.1883 11.3625H13.5945V9.7688H15.1883V11.3625ZM15.1883 14.55H13.5945V12.9563H15.1883V14.55ZM15.1883 17.4188H13.5945V15.825H15.1883V17.4188ZM15.1883 20.6063H13.5945V19.0125H15.1883V20.6063ZM12.3195 8.17505H10.7258V6.5813H12.3195V8.17505ZM9.13203 8.17505H7.53828V6.5813H9.13203V8.17505Z"
      fill="#878787"
    />
    <path
      d="M3.55391 13.7532V16.3032H5.62578V13.7532H3.55391Z"
      fill="#1677D2"
    />
    <path
      d="M6.74141 13.7532H8.81328V16.3032H6.74141V13.7532Z"
      fill="#1677D2"
    />
    <path
      d="M6.74141 17.4188V20.1282H8.81328V17.4188H6.74141Z"
      fill="#1677D2"
    />
    <path
      d="M17.8977 17.2594H19.6508V19.8094H17.8977V17.2594Z"
      fill="#1677D2"
    />
    <path
      d="M17.8977 13.7532H19.6508V16.3032H17.8977V13.7532Z"
      fill="#1677D2"
    />
    <path
      d="M17.8977 10.2469H19.6508V12.7969H17.8977V10.2469Z"
      fill="#1677D2"
    />
    <path
      d="M17.8977 4.6688V8.97192H20.607V20.925H17.8977V22.2H21.882V8.97192H22.2008V8.17505L18.6945 4.6688H17.8977Z"
      fill="#1677D2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.80078 10.2469H3.55391V8.97192H4.82891V10.2469H10.7258V22.2H1.80078V10.2469ZM2.59766 12.7969V20.925H3.55391V17.4188H5.62578V20.925H9.76953V12.7969H2.59766Z"
      fill="#1677D2"
    />
  </svg>
);
